import { render, staticRenderFns } from "./AppsPromotion.vue?vue&type=template&id=7884d724&scoped=true"
import script from "./AppsPromotion.vue?vue&type=script&lang=js"
export * from "./AppsPromotion.vue?vue&type=script&lang=js"
import style0 from "./AppsPromotion.vue?vue&type=style&index=0&id=7884d724&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884d724",
  null
  
)

export default component.exports